export default __webpack_public_path__ + "images/1e0d8aad208412eec9f4501d664ac4bb-eastern_religion.webp";